//-- React Standard
import { Card, CardBody, CardFooter, CardHeader, Col, Row, FormGroup } from 'reactstrap';
import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import Moment from 'moment';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { notificationActions } from '../../_actions';
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";


class UserNotifications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getUserNotificationsList: [],
            perPage: config.perPageData,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the users data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "_id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;
        postData.role = 'Shopkeeper';

        dispatch(notificationActions.getUserNotificationsList(apiConstants.GET_USERS_NOTIFICATIONS, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    * componenentDidUpdate()
    */
    componentWillReceiveProps(props) {
        console.log("props ", props);
        if (props.getUserNotificationsList) {
            if (props.getUserNotificationsList.getUserNotificationsList) {
                if (props.getUserNotificationsList.getUserNotificationsList.data) {

                    this.setState({
                        totalPage: props.getUserNotificationsList.getUserNotificationsList.data.pagination.totalPages,
                        totalDataCount: props.getUserNotificationsList.getUserNotificationsList.data.pagination.totalCount,
                        getUserNotificationsList: props.getUserNotificationsList.getUserNotificationsList.data.data,
                    })
                }
            }
        }
    }

    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "_id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;
        postData.role = 'Shopkeeper';

        dispatch(notificationActions.getUserNotificationsList(apiConstants.GET_USERS_NOTIFICATIONS, postData));
    }

    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;
        this.setState({ perPage: e.target.value })

        let postData = {};
        postData.page = 1;
        postData.orderBy = "_id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);
        postData.role = 'Shopkeeper';

        dispatch(notificationActions.getUserNotificationsList(apiConstants.GET_USERS_NOTIFICATIONS, postData));
    }

    /*
    *   Call from the Detail page
    */
    // backButton = () => {
    //     this.setState({
    //         varUserDetails: false
    //     });
    // }

    // handleOptionChange = (e) => {
    //     this.setState({ perPage: parseInt(e.target.value) }, () => {
    //         const { dispatch } = this.props;
    //         let postData = {};
    //         postData.page = 1;
    //         postData.orderBy = "_id";
    //         postData.orderByAscDesc = "ASC";
    //         postData.perPage = this.state.perPage;
    //         postData.role = this.state.roleType;

    //         dispatch(notificationActions.getUserNotificationsList(apiConstants.GET_USERS_NOTIFICATIONS, postData));
    //     })
    // }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;

        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <Fragment>
                            <nav className="" aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                    </li>
                                    <li className="active breadcrumb-item" aria-current="page">
                                        {siteConstants.LABEL_MY_NOTIFICATIONS}
                                    </li>
                                </ol>
                            </nav>

                            {/* <!-- Begin Page Content --> */}
                            {/* Checking the condition for detail list */}
                            <div className="container-fluid">

                                <h1 className="h3 mb-8 text-gray-800">{siteConstants.LABEL_MY_NOTIFICATIONS}</h1>

                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />
                                        </div>
                                        <Card className="mb-2">
                                            <CardBody>
                                                {
                                                    this.state.getUserNotificationsList != undefined && this.state.getUserNotificationsList.length > 0 ? this.state.getUserNotificationsList.map((notification, index) => {
                                                        return (
                                                            <Row className="mb-12 borderBottom">
                                                                <Col xs="1">
                                                                    <div className="icon-circle bg-success"><i className="fas fa-file-alt text-white"></i></div>
                                                                </Col>
                                                                <Col xs="11">
                                                                    <FormGroup>
                                                                        <a href="javascript:void(0);" className="fontBold">{notification.title}</a>
                                                                        <div className="small text-gray-500">
                                                                            {Moment(notification.notification_date).format(config.DateFormat)}
                                                                        </div>
                                                                        <div>{notification.notification_message}</div>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    }) :
                                                        <tr>
                                                            <td colSpan="8" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }
                                            </CardBody>
                                        </Card>

                                        {/* calling the another componenet */}
                                        <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />

                                    </div>
                                </div>

                            </div>
                        </Fragment>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getUserNotificationsList, language } = state;
    return {
        getUserNotificationsList,
        language
    };
}

const connectedMembership = connect(mapStateToProps)(UserNotifications);
export { connectedMembership as UserNotifications };